export const attendeesTableStyle = {
  wrapper: {
    position: 'relative',
    width: '100%',
    height: '100%',
    overflow: 'inherit',
    borderRadius: '8px',
    background: 'var(--default-white)',
    boxShadow: 'var(--box-shadow--1)',
    padding: '12px 0',
  },

  searchButton: {
    textTransform: 'inherit',
    width: '220px',

    svg: {
      width: '23px',
      height: '23px',
    },

    '@media (max-width: 1199.98px)': {
      display: 'none',
    },
  },

  tableContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: 'calc(100% - 46px)',

    '@media (max-width: 1199.98px)': {},
  },

  container: {
    padding: '0 16px',
  },

  table: {
    maxWidth: '1087px',
    tableLayout: 'fixed',
  },

  tableHeader: {
    '& > :nth-of-type(1)': {
      width: '10%',
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',

      '@media (max-width: 1199.98px)': {
        whiteSpace: 'normal',
      },

      '@media (max-width: 767.98px)': {
        display: 'none',
      },
    },
    '& > :nth-of-type(2)': {
      width: '14%',

      '@media (max-width: 767.98px)': {
        borderTopLeftRadius: '8px',
        borderBottomLeftRadius: '8px',
      },
    },
    '& > :nth-of-type(3)': {
      width: '10%',
      '@media (max-width: 767.98px)': {
        display: 'none',
      },
    },
    '& > :nth-of-type(4)': {
      width: '10%',
      '@media (max-width: 767.98px)': {
        display: 'none',
      },
    },
    '& > :nth-of-type(5)': {
      width: '14%',

      '@media (max-width: 767.98px)': {
        display: 'none',
      },
    },
    '& > :nth-of-type(6)': {
      width: '14%',

      '@media (max-width: 767.98px)': {
        display: 'none',
      },
    },
    '& > :nth-of-type(7)': {
      width: '14%',
      textTransform: 'capitalize',
    },
    '& > :nth-of-type(8)': {
      width: '6%',
      textTransform: 'uppercase',

      '@media (max-width: 1199.98px)': {
        borderTopRightRadius: '8px',
        borderBottomRightRadius: '8px',
      },
    },
    '& > :nth-of-type(9)': {
      width: '5%',

      '@media (max-width: 1199.98px)': {
        display: 'none',
      },
    },
  },

  tableBody: {
    '& > :nth-of-type(1)': {
      fontSize: '12px',

      '@media (max-width: 767.98px)': {
        display: 'none',
      },
    },

    '& > :nth-of-type(2)': {
      '@media (min-width: 1200px)': {
        '&:hover': {
          textDecoration: 'underline',
        },
      },
    },

    '& > :nth-of-type(3)': {
      '@media (max-width: 767.98px)': {
        display: 'none',
      },
    },
    '& > :nth-of-type(4)': {
      '@media (max-width: 767.98px)': {
        display: 'none',
      },
    },

    '& > :nth-of-type(5)': {
      '@media (max-width: 767.98px)': {
        display: 'none',
      },

      '& .MuiBox-root': {
        '& > .MuiTypography-root:nth-of-type(1)': {
          fontWeight: 700,
        },
        '& > .MuiTypography-root:nth-of-type(2)': {
          fontSize: '12px',
          color: 'var(--neutral-300)',
        },
      },
    },

    '& > :nth-of-type(6)': {
      '@media (max-width: 767.98px)': {
        display: 'none',
      },
    },

    '& > :nth-of-type(6) .MuiBox-root': {
      '& > .MuiTypography-root:nth-of-type(1)': {
        fontWeight: 700,
      },
      '& > .MuiTypography-root:nth-of-type(2)': {
        fontSize: '12px',
        color: 'var(--neutral-300)',
      },
    },

    '& > :nth-of-type(7) .MuiBox-root': {
      '& > .MuiTypography-root:nth-of-type(1)': {
        fontWeight: 700,
      },
      '& > .MuiTypography-root:nth-of-type(2)': {
        fontSize: '12px',
        color: 'var(--neutral-300)',
        whiteSpace: 'normal',
        overflow: 'visible',
        wordBreak: 'break-word',
      },
    },

    '& > :nth-of-type(8)': {
      textAlign: 'right',
    },

    '& > :nth-of-type(9)': {
      '@media (max-width: 1199.98px)': {
        display: 'none',
      },
    },

    '& .MuiTableCell-root': {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      height: '42px',
      paddingTop: '8px !important',
      paddingBottom: '8px !important',
    },
  },

  status: {
    '&.MuiTypography-root svg': {
      marginLeft: '4px',
      display: 'flex',
      // justifyContent: 'start',
      justifyContent: 'flex-start',
    },
  },

  menuItem: {
    width: '100%',
    padding: '8px 16px',
    cursor: 'pointer',

    '&:hover': {
      backgroundColor: 'var(--background-grey-op-50-1)',
    },
  },

  hideMenuItem: {
    color: 'var(--neutral-300)',
    cursor: 'default',
  },

  detailsModal: {
    '.MuiPaper-root': {
      position: 'relative',
      maxWidth: '1170px',
      width: '100%',
      minHeight: 'calc(100% - 48px)',
      // height: '100%',
      padding: '48px 38px 0 48px',
      scrollbarGutter: 'stable',
      margin: '0 15px',
      borderRadius: '8px',
      overflow: 'auto',

      '& > .MuiBox-root': {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      },
    },

    '@media (max-width: 1199.98px)': {
      display: 'none',
    },
  },

  profilePage: {
    '.MuiPaper-root': {
      position: 'relative',
      maxWidth: '1170px',
      width: '100%',
      maxHeight: 'calc(100% - 48px)',
      height: '100%',
      padding: '48px 38px 0 48px',
      scrollbarGutter: 'stable',
      margin: '0 15px',
      borderRadius: '8px 8px 0 0',
    },

    '&.MuiDialog-root': {
      height: 'calc(100% - 80px)',
    },
  },

  loader: {
    position: 'absolute',
    left: 'calc(50% - 25px)',
    top: '200px',
  },

  pagination: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: '16px',
    marginBottom: '12px',

    '@media (max-width: 1199.98px)': {
      display: 'none',
    },
  },

  modal: {
    '.MuiPaper-root': {
      position: 'relative',
      maxWidth: '1170px',
      width: '100%',
      height: 'calc(100% - 48px)',
      padding: '48px 48px 0 48px',
      //scrollbarGutter: 'stable',
      margin: '0 15px',
      borderRadius: '8px',
    },
  },

  pendingStatus: {
    svg: {
      '& circle': {
        fill: 'var(--neutral-400) !important',
      },
    },
  },
};
